<template>
	<div v-if="bannerList.length>0" class="recommendPage" ref="bannerSwiper">
		<swiper :options="swiperOption" ref="swiperBox1">
			<swiperSlide v-for="(it,i) in bannerList" :key="i">
				<img :src="it.resource">
			</swiperSlide>
			<div class="swiper-pagination" slot="pagination"></div>
		</swiper>
		<div class="menuLink" v-if="locationList.length>0" :class="[bgNum==0?'bg1':'bg2']">
			<div @click="goBack" class="iconfont icon-fanhui"></div>
			<div class="name">当前位置</div>
			<div class="menu_text">
				<div v-for="(it,i) in locationList" :key="i">
					<span>{{it}}</span>
					<span v-if="locationList.length>i+1" class="iconfont icon-gengduo"></span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import {
		getBanner
	} from '@/api/home/index'
	export default {
		name: 'banner',
		components: {
			swiper,
			swiperSlide,
		},
		props: {
			bgNum: {
				type: Number,
				default: 0//0蓝色 1红色
			},
		},
		data() {
			return {
				locationList:[],
				bannerList: [],
				swiperOption: {
					loop: true,
					speed: 1000,
					autoplay: false,
					allowTouchMove: false,
					autoplay: {
						delay: 3000,
						stopOnLastSlide: false,
						disableOnInteraction: false,
						pauseOnMouseEnter: true,
					},
					// 显示分页
					pagination: {
						el: ".swiper-pagination",
						clickable: true, //允许分页点击跳转
					},
					on: {
						click: function() {
							// const index = this.clickedSlide.dataset.swiperSlideIndex
							// this.goBannerUrl(index)
						}
					}
				},
			}
		},
		mounted() {
			this.getBanner();
		},
		methods: {
			getBanner() {
				getBanner({}).then(res => {
					if (res.code == 200 || res.code == 0) {
						this.bannerList = res.result;
					}
				})
			},
			goBack(){
				this.$router.go(-1);
			}
		}
	}
</script>
<style lang="scss" scoped>
	.recommendPage {
		position: relative;
		.swiper-container {
			position: relative;
			width: 100vm;

			.swiper-slide {
				width: 100%;
				color: #000;
				text-align: center;
			}

			img {
				object-fit: cover;
				height: 550px;
				width: 100%;
				vertical-align: top;
			}
			
			
		}

		/deep/ .swiper-pagination-bullet-active {
			background-color: #fff;
			width: 24px;
			border-radius: 15px;
		}
	}
	.menuLink{
		z-index: 999;
		position: absolute;
		bottom: 0;
		width: 80%;
		left: 0;
		padding: 5px 80px;
		text-align: left;
		color: #fff;
		font-size: 14px;
		display: flex;
		align-items: center;
		>div{
			display: flex;
			align-content: center;
		}
		.icon-fanhui{
			padding: 0 20px;
			font-size: 30px;
			cursor: pointer;
		}
		.name{
			font-size: 16px;
			margin-right: 20px;
		}
		.menu_text{
			// cursor: pointer;
			>div{
				display: flex;
				align-items: center;
			}
			.iconfont{
				padding: 0 5px;
			}
		}
	}
	.bg1{
		background: linear-gradient(270deg, rgba(45,132,226,0.00) 0%, #2D85E2 45%, #5B43DF 100%);
	}
	.bg2{
		background: linear-gradient(270deg, rgba(226,223,45,0.00) 0%, #FFC300 45%, #FF0000 97%);
	}
</style>
